<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <a href="/" id="logo" title="FMovies" style="margin-right: 20px"
      ><img
        src="https://fmovies.ps/images/group_17/theme_1/logo-light.png"
        alt="Logo"
        class="logoImg"
    /></a>

    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav">
        <li class="nav-item active">
          <router-link to="/" class="nav-link">Home</router-link>
        </li>
        <li class="nav-item active">
          <router-link to="/streamservice" class="nav-link"
            >Stream Service Availibility</router-link
          >
        </li>
        <li class="nav-item">
          <!-- <router-link to="/stats" class="nav-link">Stats</router-link> -->
        </li>
      </ul>
    </div>
    <div class="form-inline" style="margin-right: 20px">
      <input
        class="form-control mr-sm-2"
        type="text"
        placeholder="Search"
        aria-label="Search"
        v-model="movieTitle"
        @keyup.enter.prevent="navigateToPage"
      />
    </div>
  </nav>
  <router-view></router-view>
</template>

<script>
export default {
  data() {
    return {
      movieTitle: "",
    };
  },
  methods: {
    navigateToPage() {
      // Navigate to the desired route programmatically
      this.$router.push(`/search/${this.movieTitle}`);
    },
  },
};
</script>

<style>
.logoImg {
  height: 40px;
}
</style>
